<div
  class="similar-objects-slider"
  [class.similar-objects-slider--map-visible]="isMapVisible"
  [class.similar-objects-slider--is-panning]="isPanning"
  [class.similar-objects-slider--expanded]="isExpanded"
>
  <div class="similar-objects-slider__top">
    <div class="similar-objects-slider__header">
      <h2 class="similar-objects-slider__title">
        {{ 'similarObjects.title' | i18n }}
      </h2>

      <p class="similar-objects-slider__result-count">
        {{
          'similarObjects.xResults'
            | i18n: { count: similarObjectsCount$ | async }
        }}
      </p>
    </div>

    <div class="similar-objects-slider__controls">
      <button
        class="slider-control"
        (click)="previous()"
        [disabled]="currentIndex === 0"
      >
        <i class="slider-control__icon material-icon material-icon--outlined">
          keyboard_arrow_left
        </i>
      </button>

      <button
        class="slider-control"
        (click)="next()"
        [disabled]="currentIndex === objects.length - 1"
      >
        <i class="slider-control__icon material-icon material-icon--outlined">
          keyboard_arrow_right
        </i>
      </button>
    </div>
  </div>

  <ul
    class="similar-objects-slider__slides"
    #slidesContainer
    [style.transform]="transform"
  >
    <li
      class="similar-objects-slider__slide"
      #slide
      *ngFor="let object of objects; trackBy: trackBy; let i = index"
      [class.similar-objects-slider__slide--hide]="shouldHideSlide(i)"
    >
      <lib-list-card [data]="object" [hasSlider]="false"></lib-list-card>
    </li>

    <li class="similar-objects-slider__slide">
      <app-change-filter-card></app-change-filter-card>
    </li>
  </ul>

  <div class="similar-objects-slider__dots">
    <div
      class="similar-objects-slider__dot"
      [class.similar-objects-slider__dot--active]="i === currentIndex"
      *ngFor="let object of objects; let i = index"
      (click)="goToIndex(i)"
    ></div>

    <div
      class="similar-objects-slider__dot"
      [class.similar-objects-slider__dot--active]="
        objects.length === currentIndex
      "
      (click)="goToIndex(objects.length)"
    ></div>
  </div>
</div>
